module.exports = __webpack_public_path__ + "static/media/present-box.6fe7b8a8.webp";